import React from "react";
import useCentrosLogic from "./hooks/useCentrosLogic";
import CentrosView from "./pages/CentrosView.jsx";

export default function CentrosEducativos() {
  const logic = useCentrosLogic();
  return <CentrosView {...logic} />;
}
